<template>
    <div>
        <h2>加盟店</h2>
        <v-data-table
            :headers="headers"
            :items="stores"
            class="elevation-1"
            no-data-text="データはありません"
        >
            <template v-slot:item.is_franchise="{ item }">
                <template v-if="item.is_franchise">{{ item.is_franchise.toString().replace('true', '加入済') }}</template>
                <v-chip
                    v-else
                    color="red"
                    dark
                >
                    {{ item.is_franchise.toString().replace('false', '未加入') }}
                </v-chip>
            </template>
            <template v-slot:item.is_certification="{ item }">
                {{ item.is_certification.toString().replace('true', '加入済').replace('false', '') }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="goMainStoreDetail(item)"
                        >
                        mdi-pencil
                        </v-icon>
                    </template>
                    <span>編集する</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>
  

<script>
export default {
    data() {
        return {
            headers: [
                { text: '店舗名', value: 'store_name' },
                { text: '加盟日', value: 'date_joined' },
                { text: 'フランチャイズ店', value: 'is_franchise' },
                { text: 'プレミア店', value: 'is_certification' },
                { value: 'actions' },
            ],
            stores: [],
        }
    },
    methods: {
        goMainStoreDetail(store) {
            this.$router.push({
                name: 'MainStoreDetail',
                params: { store_id: store.store_id }
            })
        },
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/account/info`)
        .then(res => {
            this.stores = res.data
        })
    }
}
</script>


<style>
a{
    text-decoration: none;
}
a:hover{
    text-decoration: underline;
}
</style>
